























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import logger from "@/configs/logger";
import { collections } from "@/configs/firebase";
import { snakeCase } from "lodash";

@Component
export default class DispositionGroups extends Vue {
  @Prop({ required: true }) allDispositions!: string[];
  @Prop({ required: true }) groups!: any[];
  @Prop({ required: true }) getGroups!: Function;

  onSelect(val: any, group: any) {
    try {
      collections.dispositionGroups.doc(group.id).update({ dispositions: val });
    } catch (err) {
      logger("error", "select group disposition error:", err);
    }
  }

  async deleteGroup(group: any) {
    try {
      const confirmed = window.confirm(
        `Are you sure you want to delete ${group.name} group?`
      );
      if (confirmed) {
        await collections.dispositionGroups.doc(group.id).delete();
        this.getGroups();
      }
    } catch (err) {
      logger("error", "delete group error:", err);
    }
  }
}
